

import { ArrowUpward, FilterList, Instagram, YouTube } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search'; // Import the MUI search icon
import { Slider } from '@mui/material'; // Import Slider component from MUIs
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'; // Import Skeleton styless
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import '../../App.css';
import BrandHeader from "./BrandHeader";
import BrandList from './BrandList';
import Navbar from './Navbar';
const BrandHome = () => {
  const [data, setData] = useState([]);
  const [loadingMore, setLoadingMore] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchName, setSearchName] = useState('');
  const [selectedTags, setSelectedTags] = useState([]); // Track the selected tags
  const [searchCategory, setSearchCategory] = useState('');
  const [searchLocation, setSearchLocation] = useState('');
  const [searchState, setSearchState] = useState('');
  const [searchCity, setSearchCity] = useState('');
  const [categories, setCategories] = useState([]); 
  const [searchFollowersRange, setSearchFollowersRange] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [searchCostingRange, setSearchCostingRange] = useState([0, 100000]);
    const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [isItemAdded, setIsItemAdded] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // State to track the current page
    const [brandData, setBrandData] = useState(null);
    const [showPremiumModal, setShowPremiumModal] = useState(false);

  const itemsPerPage = 20; // Number of items to display per page

  const availableTags = ['Fashion', 'Food', 'Travel'];
  const navigate = useNavigate();

  // Fetch API data
  const fetchData = async () => {
    try {
      const response = await fetch('https://server-side-influencer.onrender.com/brand/allcsvinfluencers');
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      const result = await response.json();
      
      setData(result); // Store the fetched data
      const uniqueCategories = [...new Set(result.map(item => item.category))]; // Extract unique categories
      const uniqueStates = [...new Set(result.map(item => item.state))]; // Extract unique states
      const uniqueCities = [...new Set(result.map(item => item.city))]; // Extract unique cities
      setCategories(uniqueCategories); // Set unique categories
      setStates(uniqueStates); // Set unique states
      setCities(uniqueCities); // Set unique cities
    } catch (err) {
      setError(err.message); // Set error state
    } finally {
      setLoading(false); // Stop loading
    }
  };

    // Fetch brand data
    const getBrandData = async () => {
      try {
        const brandId = localStorage.getItem("brandID");
        if (!brandId) {
          console.log("Brand ID not found in localStorage");
          return;
        }
  
        const response = await fetch(`https://server-side-influencer.onrender.com/brand/getBrandData/${brandId}`);
        const data = await response.json();
        console.log("data us in wecodmm essss",data.data.shopName)
        setBrandData(data.data.shopName);
        console.log("Logged in brand is data:- ", data.data.shopName);
      } catch (err) {
        console.log(err);
        if (err.response && err.response.status === 422) {
          navigate('/');
        } else {
          toast.error("An error occurred. Please try again later.");
        }
      }
    };
  
  useEffect(() => {
    getBrandData();
    fetchData(); // Fetch data when the component mountsss
  }, []);
  // Followers Range options
  const followersRangeOptions = [
    { label: '0 - 1000', min: 0, max: 1000 },
    { label: '1000 - 5000', min: 1000, max: 5000 },
    { label: '5000 - 10000', min: 5000, max: 10000 },
    { label: '10000 - 50000', min: 10000, max: 50000 },
    { label: '50000 - 100000', min: 50000, max: 100000 },
    { label: '100000 - 500000', min: 100000, max: 500000 },
    { label: '500000 - 1000000', min: 500000, max: 1000000 },
    { label: '1000000 - 5000000', min: 1000000, max: 5000000 },
  ];

  // Function to handle when an available tag is clickeds
  const handleTagClick = (tag) => {
    // Add the tag to the search input and update the searchName state
    const updatedSearch = searchName ? `${searchName} ${tag}` : tag;
    setSearchName(updatedSearch);
    // Automatically trigger search or filtering logic if needed here
    // Example: triggerSearch(updatedSearch);
  };



  const filteredData = data.filter(
    (row) =>
      // Combine name and category for a unified search string
      `${row.name} ${row.category}`.toLowerCase().includes(searchName.toLowerCase()) &&
      row.category.toLowerCase().includes(searchCategory.toLowerCase()) &&
      // Add additional filters for other fields (location, state, city, etc.)
      row.location.toLowerCase().includes(searchLocation.toLowerCase()) &&
      row.state.toLowerCase().includes(searchState.toLowerCase()) &&
      row.city.toLowerCase().includes(searchCity.toLowerCase()) &&
  
      // Filter by followers range
      (searchFollowersRange
        ? row.followers >= followersRangeOptions[searchFollowersRange].min &&
          row.followers <= followersRangeOptions[searchFollowersRange].max
        : true) &&
  
      // Filter by costing range
      (row.costingPerSegment >= searchCostingRange[0] && row.costingPerSegment <= searchCostingRange[1]) // Filter based on costing range
  );
  
          const displayedData = filteredData.slice(0, currentPage * itemsPerPage);
          const handleSearchChange = (e) => {
            setSearchName(e.target.value);
            setLoading(true); // Start loading when user starts typings
        
            // Simulate delay for the loading (adjust as needed)
            setTimeout(() => {
              setLoading(false); // Stop loading after filtering is done
            }, 500); // Adjust delay as per your filtering logic
          };
        
   
         // Check screen width for responsiveness
         useEffect(() => {
           const handleResize = () => {
             setIsSmallScreen(window.innerWidth <= 700);
           };
       
           handleResize(); // Check initial size
           window.addEventListener('resize', handleResize);
       
           return () => {
             window.removeEventListener('resize', handleResize);
           };
         }, []);
        
          const loadMoreData = () => {
            setLoadingMore(true); // Start loading
            setTimeout(() => {
              setCurrentPage((prevPage) => prevPage + 1); // Increment page number to load more data
              setLoadingMore(false); // Stop loading after 3 seconds
            }, 3000); // 3 seconds delay for loading
          };
          // Paginate filteredData
  

  const handleDelete = async (_id) => {
    console.log("Item ID to delete:", _id);

    try {
      const response = await fetch(`http://localhost:8000/influencers/delete/${_id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        Swal.fire({
          title: "Success",
          text: "Deleted successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });
        fetchData(); // After successful deletion, fetch the updated data
      } else {
        const errorData = await response.json();
        Swal.fire({
          title: "Error",
          text: `Failed to delete item: ${errorData.message}`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An error occurred while deleting the item.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleRowSelect = (index) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(index)
        ? prevSelected.filter((id) => id !== index)
        : [...prevSelected, index]
    );
  };


    const handleUpArrow = (row) => {
    // Log the entire row data (or use it as needed)
    console.log("Up arrow clicked for row:", row);
    console.log("Name:", row.name);
    console.log("Location:", row.location);
    console.log("Followers:", row.followers);
    navigate('/allinfluencer2', { state: { influencer: row } });
    // Add more logs or logic as necessary for the other fields
  };
  


  const handleExportCSV = () => {
    if (selectedRows.length === 0) {
      Swal.fire({
        title: "Error",
        text: "Please select at least one row to export.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return; // Stop further execution if no rows are selected
    }
    const selectedRowsData = selectedRows.map((index) => filteredData[index]);
    exportCSV(selectedRowsData);
  };
  
  const exportCSV = (selectedRowsData) => {
    // All required headers
    const headers = [
      'Name',
      'Instagram Profile',
      'Followers',
      'YouTube Link',
      'Subscribers',
      'Category',
      'Contact Number',
      'Location',
      'State',
      'City',
      'Costing Per Segment',
      'Notes',
      'Hashtags',
      'Managed By',
      'Lifestyle',
      'Email',
    ];
  
    const csvRows = [];
    
    // Add the header row to the CSV
    csvRows.push(headers.join(','));
    
    // Add rows for selected data
    selectedRowsData.forEach(row => {
      const rowData = [
        row.name,
        row.instagramProfile,
        row.followers,
        row.youtubeLink,
        row.subscribers,
        row.category,
        row.contactNumber,
        row.location,
        row.state || 'No State',
        row.city || 'No City',
        row.costingPerSegment,
        row.notes || 'No Notes',  // If no notes, use 'No Notes'
        row.hashtags || 'No Hashtags',  // If no hashtags, use 'No Hashtags'
        row.managedBy || 'No Manager',  // If no manager, uses 'No Manager'
        row.lifestyle || 'No Lifestyle',  // If no lifestyle, use 'No Lifestyle'
        row.email || 'No Email',  // If no email, use 'No Email'
      ];
      
      // Push the row data to the CSV
      csvRows.push(rowData.join(','));
    });
  
    // Create a Blob with the CSV data
    const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  
    // Create a link to trigger the download
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'selected_influencers.csv';  // CSV file name
    link.click();  // Trigger the download
  };
  
  
  const handleSelectAll = () => {
    if (selectedRows.length === data.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(data.map((_, index) => index)); // Select all rows
    }
  };

  const handleLinkClick = (link) => {
    window.open(link, '_blank');
  };

  const handleEdit = (item) => {
    navigate('/edit', { state: { item } });
  };

  const handleAddItem = async (_id) => {
    try {
      const managerId = localStorage.getItem('brandID');
      if (!managerId) {
        Swal.fire({
          title: "Error",
          text: 'Manager ID not found in localStorage',
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      const response = await fetch(`https://server-side-influencer-production.up.railway.app/brand/addInfluencer/${managerId}/${_id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        Swal.fire({
          title: "Success",
          text: 'Added successfully!',
          icon: "success",
          confirmButtonText: "OK",
        });
        setIsItemAdded(true); 
      } else {
        const errorData = await response.json();
        Swal.fire({
          title: "Error",
          text: `${errorData.message}`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error('Error occurred:', error);
    }
  };
    // Handler for costing range change
  const handleCostingRangeChange = (event, newValue) => {
    setSearchCostingRange(newValue);
  };
  
  const handleResetFilters = () => {
    setSearchName('');
    setSearchCategory('');
    setSearchLocation('');
    setSearchState('');
    setSearchCity('');
    setSearchFollowersRange('');
    setSearchCostingRange([0, 100000]);
  };

    // Function to remove a tag from the search input
    const removeTag = (tag) => {
      // Remove the tag from the selectedTags array
      setSelectedTags(selectedTags.filter((selectedTag) => selectedTag !== tag));
  
      // Update the search input by removing the tags
      const updatedSearch = searchName
        .split(' ')
        .filter((word) => word !== tag)
        .join(' ');
      setSearchName(updatedSearch);
    };

  if (loading) {
    // return <div>Loading...</div>;sss
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="flex h-screen mb-0  page-scroll ">
       <div className="  text-white fixed top-0 left-0 bottom-0 z-10">
        <Navbar />
      </div>     
        {/* <Navbar /> */}
   
        <div className="flex-2 page-scroll p-0 mb-1" 
     style={{
        marginRight: isSmallScreen ? '2px' : '0px',
        marginLeft: isSmallScreen ? '2px' : '70px',
     }}>

        <BrandHeader page="Brand Home" />

        <div className="text-right text-sm sm:text-base md:text-lg lg:text-2xl font-semibold mr-8   sm:mt-0 text-gray-700 "  style={{ marginTop: '30px' }}>
                👏 Welcome back,{brandData}
              </div>
<h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-extrabold text-center text-black mt-[50px] mb-[50px] cursor-pointer hover:text-gray-700 transition-all duration-300 ease-in-out transform hover:scale-105 ml-[50px] sm:ml-0 break-words">
  Start Searching Influencers 
  <span className="block text-base sm:text-sm md:text-base lg:text-lg font-normal text-gray-600 mt-0 ml-[20px] sm:ml-0 break-words">
    Discover top influencers to elevate your brand's reach and impact.
   </span>
</h1>





{/* <div className="flex-grow" style={{ marginLeft: "83%", marginTop: "0%" }}>

  <BrandList />

</div>  */}

{/* 
<div className="flex-grow" style={{ marginLeft: "79%" }}>
{isItemAdded &&
  <BrandList />
}
</div>  */}



<div className="flex justify-center items-center">
      <div className="mb-4 w-full max-w-3xl">
        <div className="relative mt-2">
          {/* Search Input */}
          <input
            type="text"
            value={searchName}
            onChange={handleSearchChange}
            className="block w-full p-2.5 pl-10 bg-[#F2F4F8] border border-gray-300 text-gray-900 rounded-lg"
            placeholder="Search influencers by names or keywords"
          />
          {/* MUI Search Icon inside the input field */}
          <SearchIcon
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
            fontSize="small"
          />

          {/* Display selected tags inside the search input */}
          <div className="absolute top-1/2 left-10 transform -translate-y-1/2 flex gap-2 flex-wrap w-full">
            {selectedTags.map((tag, index) => (
              <span
                key={index}
                className="flex items-center bg-gray-200 text-gray-800 p-2 rounded-full"
              >
                {tag}
                {/* Cross (×) button to remove the tag */}
                <button
                  className="ml-2 text-red-500"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering handleTagClick when clicking "×"
                    removeTag(tag);
                  }}
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        </div>

      

        <div className="mt-4 flex flex-wrap gap-2">
  {availableTags.map((tag, index) => (
    <span
      key={index}
      className="flex items-center text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-full text-sm px-5 py-2.5 text-center cursor-pointer"
      onClick={() => handleTagClick(tag)} // Add the tag to the search input when clicked
    >
      {tag}
    </span>
  ))}
</div>


      </div>
    </div>
        <div className="flex justify-center mt-[-5%] mb-0">
          <div className="text-center mt-[10%] ml-[60%] mb-5">
         
          </div>

          {/* Drawer componentss */}
          {drawerOpen && (
            <div className="fixed top-0 left-0 z-40 h-screen p-4 overflow-y-auto transition-transform bg-white w-80 dark:bg-gray-800  ">
              <h5 className="text-gray-500 dark:text-gray-400 text-lg font-semibold mb-6 mt-12">Search Filters</h5>

              
              <button
  onClick={handleResetFilters}
  className=" mt-10 text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
>
  Reset filters
</button>
              <button
                type="button"
                onClick={() => setDrawerOpen(false)}
                className="absolute top-2.5 right-2.5 text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8  mt-12"
              >
                <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                </svg>
              </button>

           
           
         
              <div className="mb-4  mt-10">
                <label className="text-sm font-medium text-gray-900 dark:text-white">Category</label>
                <select
                  value={searchCategory}
                  onChange={(e) => setSearchCategory(e.target.value)}
                  className="block w-full mt-2 p-2.5 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg"
                >
                  <option value="">Select Category</option>
                  {categories.map((category, index) => (
                    <option key={index} value={category}>{category}</option>
                  ))}
                </select>
              </div>
              <div className="mb-4">
                <label className="text-sm font-medium text-gray-900 dark:text-white">Location</label>
                <input
                  type="text"
                  value={searchLocation}
                  onChange={(e) => setSearchLocation(e.target.value)}
                  className="block w-full mt-2 p-2.5 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg"
                  placeholder="Search by location"
                />
              </div>

              {/* New State Dropdowns */}
              <div className="mb-4">
                <label className="text-sm font-medium text-gray-900 dark:text-white">State</label>
                <select
                  value={searchState}
                  onChange={(e) => setSearchState(e.target.value)}
                  className="block w-full mt-2 p-2.5 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg"
                >
                  <option value="">Select State</option>
                  {states.map((state, index) => (
                    <option key={index} value={state}>{state}</option>
                  ))}
                </select>
              </div>
      {/* Followers Range Dropdown */}
                    <div className="mb-4">
            <label className="text-sm font-medium text-gray-900 dark:text-white">Followers Range</label>
           <select
                  value={searchFollowersRange}
                  onChange={(e) => setSearchFollowersRange(e.target.value)}
                  className="block w-full mt-2 p-2.5 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg"
                >
                  <option value="">Select Followers Range</option>
                  {followersRangeOptions.map((option, index) => (
                    <option key={index} value={index}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
       

              <div className="mb-4">
                <label className="text-sm font-medium text-gray-900 dark:text-white">Costing Per Segment</label>
                <Slider
                  value={searchCostingRange}
                  onChange={handleCostingRangeChange}
                  valueLabelDisplay="auto"
                  valueLabelFormat={(value) => `₹${value}`}
                  min={0}
                  max={100000}
                  step={1000}
                  className="mt-2"
                />
              </div>
              {/* New City Dropdown */}
              <div className="mb-4">
                <label className="text-sm font-medium text-gray-900 dark:text-white">City</label>
                <select
                  value={searchCity}
                  onChange={(e) => setSearchCity(e.target.value)}
                  className="block w-full mt-2 p-2.5 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg"
                >
                  <option value="">Select City</option>
                  {cities.map((city, index) => (
                    <option key={index} value={city}>{city}</option>
                  ))}
                </select>
              </div>
            </div>




          )}
        </div>

 


      <div className="flex justify-end w-full">
 

<div className="flex justify-between items-start p-8 ml-5">
      <div className="flex-grow ">
        {/* Brand list goes here */}
        < BrandList />
      </div> 


<button
  onClick={() => setDrawerOpen(true)}
  className="text-sm px-4 py-2 mb-2 text-gray-900 border border-gray-400 bg-gray-100 hover:bg-gray-200 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg focus:outline-none dark:bg-gray-600 dark:hover:bg-gray-700 dark:border-gray-500 dark:focus:ring-gray-800 whitespace-nowrap sm:text-base sm:px-5 sm:py-2.5 ml-13"
  style={{ marginLeft: '60px' }}
  type="button"
>
  <FilterList className="mr-2" />
  Filters

  

</button>


      </div>
    </div>
        {/* Table for displaying filtered influencer datas */}
        <p className="text-black-600  mb-10 ml-12" >
  Showing {filteredData.length} results
</p>

        {/* <div className="relative overflow-x-auto shadow-md sm:rounded-lg max-h-[calc(100vh-250px)] mt-[-1%] mb-0 ml-0"> */}
        <div className="relative page-scroll shadow-md sm:rounded-lg max-h-[calc(100vh-250px)] mt-[-1%] mb-8 sm:mb-0 sm:ml-0 ml-4">
        <div className="mt-4 text-right">

     

</div>



<table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400  mt-10 ">
        <thead className="text-xs text-black uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">
              <input
                type="checkbox"
                checked={selectedRows.length === filteredData.length}
                onChange={handleSelectAll}
                style={{
                  cursor: 'pointer',
                  width: '20px',
                  height: '14px',
                  transition: 'all 0.3s ease',
                }}
              />
            </th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Name</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Instagram Profile</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Followers</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">YouTube Link</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Subscribers</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Category</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Contact Number</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Location</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">State</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">City</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Costing Per Segment</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Notes</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Hashtags</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Managed By</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Lifestyle</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Email</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Actions</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">More</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            // Show Skeleton Loader if loading is true
            <tr>
              <td colSpan="17" className="text-center py-4 text-gray-500">
                <Skeleton count={10} height={40} />
              </td>
            </tr>
          ) : filteredData.length === 0 ? (
            <tr>
              <td colSpan="17" className="text-center py-4 text-gray-500 text-3xl">
                No search result found
              </td>
            </tr>
          ) : (
            displayedData.map((row, index) => (
              <tr
                key={index}
                className={`bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 ${
                  selectedRows.includes(index) ? 'bg-blue-100 dark:bg-blue-600' : ''
                }`}
              >
                <td className="px-6 py-4">
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(index)}
                    onChange={() => handleRowSelect(index)}
                  />
                </td>
                <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{row.name}</td>
                <td className="px-6 py-4">
                  <Instagram
                    onClick={() => handleLinkClick(row.instagramProfile)}
                    className="cursor-pointer text-blue-600 hover:text-blue-800"
                  />
                </td>
                <td className="px-6 py-4">{row.followers}</td>
                <td className="px-6 py-4">
                  <YouTube
                    onClick={() => handleLinkClick(row.youtubeLink)}
                    className="cursor-pointer text-red-600 hover:text-red-800"
                  />
                </td>
                <td className="px-6 py-4">{row.subscribers}</td>
                <td className="px-6 py-4">{row.category}</td>
                <td className="px-6 py-4">
  <div
  onClick={() => setShowPremiumModal(true)}
    className="blur-sm cursor-pointer text-blue-500 hover:underline"
    title="Click to view"
  >

   
    {row.contactNumber}
  </div>
</td>
                <td className="px-6 py-4">{row.location}</td>
                <td className="px-6 py-4">{row.state || 'No State'}</td>
                <td className="px-6 py-4">{row.city || 'No City'}</td>
                <td className="px-6 py-4">{row.costingPerSegment}</td>
                <td className="px-6 py-4">{row.notes}</td>
                <td className="px-6 py-4">{row.hashtags}</td>
                <td className="px-6 py-4">{row.managedBy}</td>
                <td className="px-6 py-4">{row.lifestyle}</td>
            

                <td className="px-6 py-4">
  <div
  onClick={() => setShowPremiumModal(true)}
    className="blur-sm cursor-pointer text-blue-500 hover:underline"
    title="Click to view"
  >
    {row.email}
  </div>
</td>
                <td className="px-6 py-4">
                  <div className="flex space-x-2">
                    <button
                      onClick={() => handleAddItem(row._id)}
                      className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 whitespace-nowrap"
                    >
                      Add to list
                    </button>
                  </div>
                </td>
                <td>
                  <ArrowUpward
                    onClick={() => handleUpArrow(row)} // Pass the entire row to the functionsd
                    className="cursor-pointer text-gray-600 hover:text-gray-800"
                    style={{ marginLeft: '30px' }} // Apply left margin of 30px
                  />
                </td>
              </tr>
            ))
          )}
        </tbody>



      </table>




{filteredData.length > 0 && filteredData.length > 20 && (
  <div className="text-center mt-4">
    {!loadingMore ? (
      <button
        onClick={loadMoreData}
        className="bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 ml-8 text-white"
      >
        Load More
      </button>
    ) : (
      <div style={{ marginTop: '10px', fontSize: '16px', color: '#555' }}>
        Loading...
      </div>
    )}
  </div>
)}













     
      </div>

      <div className="mt-4 text-right">
          <button
          
          onClick={handleExportCSV}  className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
          >
            Export Selected Rows as CSV
          </button>
        </div>



        {showPremiumModal && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full text-center">
      <h2 className="text-xl font-semibold mb-4">Premium Access Required</h2>
      <p className="mb-6"> only available for premium users.</p>
      <button
        onClick={() => setShowPremiumModal(false)}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        Close
      </button>
    </div>
  </div>
)}











         </div>   
    </div>
  );
};

export default BrandHome;






















































































